import { useCallback } from 'react';
var nativeEnterTarget = ['button', 'a', 'textarea', '[contenteditable]:not([contenteditable="false"])', '[role="button"]', '[role="combobox"]', '[role="listbox"]', '[role="menu"]', '.ant-select', '.ant-select-dropdown', '.ant-picker', '.ant-picker-dropdown'].join(','); // Opt in at the modal boundary; native controls keep their own Enter behavior.

export function useModalEnter(onEnter) {
  var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return useCallback(function (event) {
    var _event$currentTarget$;

    if (!onEnter || event.key !== 'Enter' || event.defaultPrevented || event.nativeEvent.isComposing || event.nativeEvent.keyCode === 229 || event.ctrlKey || event.altKey || event.metaKey || event.shiftKey) return;
    var target = event.target;
    if (!(target instanceof HTMLElement) || target.closest(nativeEnterTarget)) return;
    var dialog = target.closest('[role="dialog"]');
    var boundaryDialog = (_event$currentTarget$ = event.currentTarget.closest('[role="dialog"]')) !== null && _event$currentTarget$ !== void 0 ? _event$currentTarget$ : event.currentTarget.querySelector('[role="dialog"]');
    if (!dialog || boundaryDialog !== dialog) return;
    var dialogs = Array.from(document.querySelectorAll('[role="dialog"]')).filter(function (item) {
      return item.getClientRects().length > 0;
    });
    var topmost = dialogs.reduce(function (top, item) {
      var layer = function layer(element) {
        var _element$closest;

        return Number(getComputedStyle((_element$closest = element.closest('.ant-modal-wrap')) !== null && _element$closest !== void 0 ? _element$closest : element).zIndex) || 0;
      };

      return !top || layer(item) >= layer(top) ? item : top;
    }, undefined);
    if (topmost !== dialog) return; // Also prevent implicit form submit while the modal's action is disabled.

    event.preventDefault();
    event.stopPropagation();
    if (!disabled && !event.repeat) onEnter();
  }, [disabled, onEnter]);
}